<template>
    <v-dialog v-model="visible" width="500">
        <template #activator="{ props: activatorProps }">
            <v-list-item v-bind="activatorProps" @click="open">
                <v-list-item-title v-text="$t('archiv.table.burgermenu.edit')" />
            </v-list-item>
        </template>
        <Form v-slot="{ meta }">
            <FocusLock>
                <form id="focusLockDialogForm" @submit.prevent="submit">
                    <v-card>
                        <v-card-title class="headline font-weight-bold mb-2">
                            {{ $t('praxisgruppe.einstellungen.edituserdialog.title') }}
                        </v-card-title>
                        <v-card-text class="pb-0">
                            <v-text-field
                                v-model="benutzerCopy.loginId"
                                :label="$t('einstellungen.addaccount.email') + '*'"
                                placeholder="example@test.com"
                                disabled
                                readonly
                            ></v-text-field>
                            <v-select
                                v-model="benutzerCopy.rollen"
                                :item-props="itemProps"
                                :items="praxisgruppeBenutzerRollen"
                                :label="$t('einstellungen.addaccount.rolle')"
                                :menu-props="{ attach: '#focusLockDialogForm' }"
                            ></v-select>
                            <Field
                                v-slot="{ errors, field }"
                                v-model="benutzerCopy.vorname"
                                name="Vorname"
                                :rules="getValidation('benutzerCreateApiDto.vorname')"
                            >
                                <v-text-field
                                    v-bind="field"
                                    v-model="benutzerCopy.vorname"
                                    :label="$t('einstellungen.addaccount.vorname') + '*'"
                                    placeholder="..."
                                    :error-messages="errors"
                                ></v-text-field>
                            </Field>
                            <Field
                                v-slot="{ errors, field }"
                                v-model="benutzerCopy.nachname"
                                name="Nachname"
                                :rules="getValidation('benutzerCreateApiDto.nachname')"
                            >
                                <v-text-field
                                    v-bind="field"
                                    v-model="benutzerCopy.nachname"
                                    :label="$t('einstellungen.addaccount.nachname') + '*'"
                                    placeholder="..."
                                    :error-messages="errors"
                                ></v-text-field>
                            </Field>
                            <Field
                                v-slot="{ errors, field }"
                                v-model="benutzerCopy.mobilNummer"
                                name="MobilNummer"
                                :rules="getValidation('benutzerCreateApiDto.mobilNummer') + '|valid_swiss_telephone_number'"
                            >
                                <v-text-field
                                    v-bind="field"
                                    v-model="benutzerCopy.mobilNummer"
                                    :label="$t('einstellungen.addaccount.mobilnummer') + '*'"
                                    placeholder="+41 77 111 22 33"
                                    :error-messages="errors"
                                ></v-text-field>
                            </Field>
                        </v-card-text>

                        <v-card-actions class="ml-4">
                            <v-btn color="primary" :disabled="!meta.valid || requiredFieldsFilled" variant="flat" class="modalbutton mb-3" @click="onSave">
                                {{ $t('components.dialog.save') }}
                            </v-btn>
                            <v-btn class="modalbutton mb-3" variant="flat" @click="visible = false">
                                {{ $t('components.dialog.cancel') }}
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </form>
            </FocusLock>
        </Form>
    </v-dialog>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-facing-decorator';

import { namespace } from 'vuex-facing-decorator';
import { Form, Field } from 'vee-validate';

import { NAME as NAME_EINSTELLUNGEN } from '../store';
const praxisgruppeAdministrationModul = namespace(NAME_EINSTELLUNGEN);

import { NAME as NAME_VALIDATION } from '@/store/modules/validation';
const validationModul = namespace(NAME_VALIDATION);

import { GET_VALIDATION_KEY } from '@/store/modules/validation/getters';
import { EDIT_ACCOUNT, GET_EDIT_ACCOUNT } from '../store/actions';

import { BenutzerEditApiDto } from '@/api-schema';

@Component({
    components: {
        Form,
        Field
    }
})
export default class EditAccountDialogPraxissgruppen extends Vue {
    @Prop({ required: true, type: String })
    private editBenutzerId!: string;

    private visible = false;
    private benutzerCopy: BenutzerEditApiDto = {};

    @praxisgruppeAdministrationModul.Action(EDIT_ACCOUNT) edit!: Function;
    @praxisgruppeAdministrationModul.Action(GET_EDIT_ACCOUNT) getAccount!: Function;

    @validationModul.Getter(GET_VALIDATION_KEY) getValidation!: (key: string) => string;

    get praxisgruppeBenutzerRollen(): Array<object> {
        return [
            {
                title: this.$t('benutzerrollen.praxisgruppe.user'),
                beschreibung: this.$t('benutzerrollen.praxisgruppe.user.helptext'),
                value: 'PraxisgruppeUser'
            },
            {
                title: this.$t('benutzerrollen.praxisgruppe.main'),
                beschreibung: this.$t('benutzerrollen.praxisgruppe.main.helptext'),
                value: 'PraxisgruppeMain'
            }
        ];
    }

    private onSave() {
        this.edit(this.benutzerCopy).then(() => {
            this.visible = false;
            this.$emit('success');
        });
    }

    private open() {
        this.$emit('open');
        this.getAccount(this.editBenutzerId).then((response: any) => {
            this.benutzerCopy = Object.assign({}, response);
            this.visible = true;
        });
    }

    submit() {
        this.onSave();
    }

    private itemProps(item) {
        return {
            title: item.title,
            subtitle: item.beschreibung
        };
    }

    get requiredFieldsFilled(): boolean {
        if (this.benutzerCopy.nachname !== undefined || this.benutzerCopy.vorname !== undefined) {
            return this.benutzerCopy.nachname.length === 0 || this.benutzerCopy.vorname.length === 0;
        }
        return true;
    }
}
</script>
